import * as React from 'react';

const SvgDashboard = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 18 18'}
    {...props}
  >
    <path
      fill={'currentColor'}
      d='M17 6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H6V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v6H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1V6Zm-3 6h-1a1 1 0 0 0-1 1v1H6v-1a1 1 0 0 0-1-1H4V6h1a1 1 0 0 0 1-1V4h6v1a1 1 0 0 0 1 1h1Z'
    />
  </svg>
);
export default SvgDashboard;
